import { Stack } from 'expo-router';

export default function ChatScreensLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="[chatId]"
        options={{
          title: 'Chat',
        }}
      />
      <Stack.Screen
        name="new-direct"
        options={{
          title: 'New Chat',
          presentation: 'modal',
        }}
      />
      <Stack.Screen
        name="new-group"
        options={{
          title: 'New Group',
          presentation: 'modal',
        }}
      />
      <Stack.Screen
        name="group-settings"
        options={{
          title: 'Group Settings',
        }}
      />
    </Stack>
  );
}

